import LinearEquationOne from "./LinearEquationOne";
export default LinearEquationOne